import { TRuleSources } from 'meta/rule_sources'

const rule_sources = {
  BATTLETOME_OGOR_MAWTRIBES: {
    name: 'Battletome: Ogor Mawtribes',
    type: 'battletome',
  },
  ERRATA_APRIL_2023: {
    name: 'Errata (April 2023)',
    type: 'errata',
    url: 'https://www.warhammer-community.com/wp-content/uploads/2020/07/AmayJMooi82E8FI5.pdf',
  },
} satisfies TRuleSources

export default rule_sources
